import iconCaret from "../photos/caret.svg";
import { ListItem } from "./ListItem/ListItem";

const Recommendation = ({
  setOpenRecommendation,
  openRecommendation,
  setRoomInput,
  t,
  containerHeight,
}) => {
  return (
    <div>
      <div
        className="container-row top-margin-m"
        style={{ alignItems: "center" }}
      >
        <div
          className="container-row-start "
          onClick={() => setOpenRecommendation(!openRecommendation)}
        >
          <div className="text-h2">{t("tips")}</div>
          <img
            style={{
              paddingLeft: "16px",
              paddingRight: "16px",
              rotate: "180deg",
            }}
            src={iconCaret}
            alt=""
            className={
              openRecommendation
                ? "rotate top-margin-s"
                : "rotate-back top-margin-s"
            }
          />
        </div>
      </div>
      {openRecommendation && (
        <div
          style={{
            height: containerHeight - 500,
            overflow: "hidden",
            overflowY: "scroll",
          }}
          className={openRecommendation ? "recommendation-slide-in" : ""}
        >
          <ListItem
            recPreview={t("rec-1-preview")}
            recText={t("rec-1-text")}
            setRoomInput={setRoomInput}
          />
          <ListItem
            recPreview={t("rec-2-preview")}
            recText={t("rec-2-text")}
            setRoomInput={setRoomInput}
          />
          <ListItem
            recPreview={t("rec-3-preview")}
            recText={t("rec-3-text")}
            setRoomInput={setRoomInput}
          />
          <ListItem
            recPreview={t("rec-16-preview")}
            recText={t("rec-16-text")}
            setRoomInput={setRoomInput}
          />
          <ListItem
            recPreview={t("rec-4-preview")}
            recText={t("rec-4-text")}
            setRoomInput={setRoomInput}
          />
          <ListItem
            recPreview={t("rec-5-preview")}
            recText={t("rec-5-text")}
            setRoomInput={setRoomInput}
          />
          <ListItem
            recPreview={t("rec-6-preview")}
            recText={t("rec-6-text")}
            setRoomInput={setRoomInput}
          />
          <ListItem
            recPreview={t("rec-7-preview")}
            recText={t("rec-7-text")}
            setRoomInput={setRoomInput}
          />
          <ListItem
            recPreview={t("rec-8-preview")}
            recText={t("rec-8-text")}
            setRoomInput={setRoomInput}
          />
          <ListItem
            recPreview={t("rec-9-preview")}
            recText={t("rec-9-text")}
            setRoomInput={setRoomInput}
          />
          <ListItem
            recPreview={t("rec-10-preview")}
            recText={t("rec-10-text")}
            setRoomInput={setRoomInput}
          />
          <ListItem
            recPreview={t("rec-11-preview")}
            recText={t("rec-11-text")}
            setRoomInput={setRoomInput}
          />
          <ListItem
            recPreview={t("rec-12-preview")}
            recText={t("rec-12-text")}
            setRoomInput={setRoomInput}
          />
          <ListItem
            recPreview={t("rec-13-preview")}
            recText={t("rec-13-text")}
            setRoomInput={setRoomInput}
          />
          <ListItem
            recPreview={t("rec-14-preview")}
            recText={t("rec-14-text")}
            setRoomInput={setRoomInput}
          />
          <ListItem
            recPreview={t("rec-15-preview")}
            recText={t("rec-15-text")}
            setRoomInput={setRoomInput}
          />
          <ListItem
            recPreview={t("rec-17-preview")}
            recText={t("rec-17-text")}
            setRoomInput={setRoomInput}
          />
        </div>
      )}
    </div>
  );
};

export default Recommendation;
